// IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 Д8): ссылка на запись в адресе — &open_record=<id>&open_segment=<сегмент> (письма S&OP, «Copy link»
// карточки кейса). router.beforeEach кладёт её в store.openRecord_fromURL вместе с целью — столом и страницей адреса (openRecord_fromQuery). Забирают её:
//   - workspace_show_widgets — страница строится (первый показ): форма открывается после старта виджетов страницы, пауза 1,5 с (как было);
//   - workspace_activate — страница УЖЕ построена (смена hash на открытой странице или на странице, открытой раньше): show_widgets не зовётся,
//     и ссылка висела в сторе до следующего построения страницы. Забирается, если активируется страница цели; пауза короткая.
// Модуль без импортов: store и window приходят параметрами (юнит: tests/unit/openRecordLink.test.mjs).

export const OPEN_RECORD_DELAY_BUILD = 1500   // страница строится: форма после старта виджетов страницы (прежняя пауза)
export const OPEN_RECORD_DELAY_BUILT = 100    // страница уже построена: только дать закончиться навигации

// ссылка из query маршрута (router.beforeEach): { id, segment, workspace, page } — цель ссылки = стол и страница адреса; ключи open_record / open_segment
// из query УДАЛЯЮТСЯ. Не зануляются: ключ страницы в App.routeViewKey строится из всех ключей query, open_record=null давал новый ключ — уже построенная
// страница создавалась заново (keep-alive), и её виджеты схлопывались в плашки (замер на Demo 29.09: MainArea — новый экземпляр, список 740×1012 → 370×37)
export function openRecord_fromQuery(query) {
    if (!query || !query.open_record) return null
    const link = { id: query.open_record, segment: query.open_segment || '', workspace: query.workspace || '', page: query.page || '' }
    delete query.open_record
    delete query.open_segment
    return link
}

// ссылка ли это для страницы workspace / page: цель ссылки не задана — для любой
export function openRecord_forPage(link, workspace, page) {
    if (!link || !link.id) return false
    if (link.workspace && workspace && String(link.workspace) !== String(workspace)) return false
    if (link.page && page && String(link.page) !== String(page)) return false
    return true
}

// забрать ссылку из стора, открыть форму записи (widget-record подчинённым виджетом) и убрать open_record / open_segment из адреса.
// opts: workspace / page — активируемая страница (заданы — ссылка забирается, только если цель та же), delay — пауза перед открытием, win — window.
// true — ссылка забрана
export function openRecord_take(store, opts = {}) {
    const link = store && store.openRecord_fromURL
    if (!link || !link.id) return false
    const { workspace = '', page = '', delay = OPEN_RECORD_DELAY_BUILD } = opts
    const win = opts.win || globalThis.window
    if ((workspace || page) && !openRecord_forPage(link, workspace, page)) return false
    store.openRecord_fromURL = null
    const open = () => {
        try {
            store.executeStoreMethod({}, { command: 'widget_open', widget: 'widget-record',
                open_in_children_widget: true, item: { id: link.id, segment: link.segment || undefined } })
        } catch (e) { console.warn('open_record link ignored:', e) }
    }
    if (win && win.$cg && typeof win.$cg.setTimeout === 'function') win.$cg.setTimeout(store, 'openRecord_fromURL', open, delay)
    else setTimeout(open, delay)
    try {
        const href = String((win && win.location && win.location.href) || '')
        if (href.includes('open_record=')) win.history.replaceState(win.history.state, '', href.replace(/&open_(record|segment)=[^&]*/g, ''))
    } catch (e) { /* адрес оставляем как есть */ }
    return true
}

export default { OPEN_RECORD_DELAY_BUILD, OPEN_RECORD_DELAY_BUILT, openRecord_fromQuery, openRecord_forPage, openRecord_take }
